import { createActionGroup, emptyProps } from '@ngrx/store';

export const LoadingActions = createActionGroup({
  source: 'Loading',
  events: {
    loading_start: emptyProps(),
    loading_end: emptyProps()
  }
});
